<template>
    <div class="bg-leonard-grey rounded-md grid md:grid-flow-row md:grid-cols-[1fr_auto_auto] gap-2 items-center my-4 p-4">
        <h3 v-if="title">{{title}}</h3>
        <div v-if="!title" aria-hidden="true"></div>
        <button
            type="button"
            class="font-medium transition-all duration-300 border-2 rounded-md block md:inline-block w-full md:w-auto py-2 px-3 md:px-4 bg-leonard-transparent border-leonard-green text-leonard-green hover:bg-leonard-green hover:border-transparent hover:text-leonard-white focus:ring-leonard-green cursor-pointer"
            v-if="!disableBack"
            @click="back"
            aria-label="Go Back to Previous Step">
            <font-awesome-icon :icon="['fas', 'arrow-left']" class="hidden md:inline-block"></font-awesome-icon>
            Back
        </button>
        <button
            type="button"
            class="font-medium transition-all duration-300 border-2 rounded-md block md:inline-block w-full md:w-auto py-2 px-3 md:px-4 bg-leonard-green border-leonard-green text-leonard-white hover:bg-leonard-green-hover hover:border-transparent focus:ring-leonard-green cursor-pointer disabled:bg-leonard-green-disabled disabled:text-leonard-green disabled:cursor-not-allowed"
            :class="{'ml-auto': this.$route.params.step === 'yearbook'}"
            @click="next"
            aria-label="Continue to Next Step"
            v-if="button_text">
            {{button_text || 'Continue'}}
            <font-awesome-icon :icon="['fas', 'arrow-right']" class="hidden md:inline-block"></font-awesome-icon>
        </button>
        <slot></slot>
    </div>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faArrowRight, faArrowLeft } from '@fortawesome/free-solid-svg-icons';

    export default {
        props: ['button', 'title', 'favorites', 'disableBack'],

        data() {
            return {
                button_text: this.button,
            }
        },

        created() {
            library.add(faArrowRight, faArrowLeft);
        },

        mounted() {
            $('[data-toggle="tooltip"]').tooltip();
        },

        methods: {
            next() {
                this.$emit('clicked');
            },

            back() {
                this.$emit('back');
            }
        }
    }
</script>
